export const base = 'gateway/main';
export const baseODATA = 'gateway/mainodata';

export const getQueryODATA = `${baseODATA}/resalesearchquery`;
export const getAllResale = `${base}/resale`;
export const getResaleById = `${base}/resale`;
export const postRelase = `${base}/resale`;
